import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 250, // Threshold where the "read-more" button appears
  title: 'Opera',
  type: 'work',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
    ],
    content: [
      {
        id: 'collection-digital-edition',
        type: 'collection',
        grid: 1,
        title: '',
      },
      {
        id: 'text-viewer',
        type: 'text-viewer',
        options: {
          searchId: 'xml_text',
        },
      },
      {
        id: 'metadata',
        type: 'metadata',
        title: '',
        options: {
          readmore: {
            height: 250,
            labels: {
              more: 'readmore#more',
              less: 'readmore#less',
            },
          },
        },
      },
      {
        id: 'collection-relations',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_relations',
      },
      {
        id: 'collection-letters',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_letters',
      },
      // {
      //   id: 'collection-commented',
      //   type: 'collection',
      //   grid: 1,
      //   title: 'resource#collection_commented',
      // },
    ],
  },
} as ConfigMurucaResourceLayout;
